var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Lager_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1366 768",
    style: {
      enableBackground: "new 0 0 1366 768"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#2442A4;}\n\t.st1{fill:#00F6FF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M353.674,568.215H178.513c-19.631,0-35.544-15.914-35.544-35.544V235.329 c0-19.631,15.914-35.544,35.544-35.544h175.161c19.631,0,35.544,15.914,35.544,35.544v297.342 C389.218,552.302,373.304,568.215,353.674,568.215z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "318.466,312.378 318.465,312.381 309.169,319.712 257.473,319.712 252.104,312.378 252.104,312.374  261.4,305.043 313.096,305.043  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "248.769,315.008 248.772,315.008 254.139,322.339 240.287,374.035 230.987,381.37 230.984,381.37  225.617,374.039 239.469,322.343  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "301.2,386.63 301.203,386.63 306.57,393.961 292.718,445.657 283.418,452.992 283.415,452.992  278.048,445.661 291.9,393.965  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "299.274,384 299.273,384.004 289.978,391.335 238.282,391.335 232.912,384 232.913,383.997  242.209,376.665 293.905,376.665  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "280.083,455.622 280.082,455.626 270.787,462.957 219.091,462.957 213.721,455.622 213.722,455.619  223.018,448.288 274.714,448.288  "
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M547.77,346.674l-25.677,13.667c-5.317-11.214-12.955-20.461-22.364-12.681c-7.802,9.802-0.218,15.818,14.909,22.571 c25.333,13.197,41.025,21.774,41.831,46.847c0.659,53.527-80.303,56.053-95.945,8.925l26.505-12.286 c3.68,6.443,6.488,10.539,8.421,12.286c8.039,7.894,30.745,8.369,29.266-6.024c-0.178-15.356-18.321-21.591-31.061-27.659 c-44.209-16.851-28.172-75.878,15.739-75.375C526.601,316.944,539.394,328.914,547.77,346.674z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M682.148,323.758h31.199v134.459h-31.199v-14.081c-43.522,42.817-108.681,3.356-105.467-53.565 c-3.211-56.681,64.056-96.107,105.467-51.214V323.758z M608.43,390.574c-1.05,58.153,76.227,58.182,75.651,0.69 C684.771,334.206,608.545,333.639,608.43,390.574z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M780.969,225.054v233.164h-31.061V225.054H780.969z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M914.14,225.054h31.199v233.164H914.14v-14.081c-42.713,42.936-108.94,3.398-105.467-53.565 c-3.122-56.603,64.046-96.132,105.467-51.214V225.054z M840.422,390.574c-1.05,58.153,76.228,58.182,75.651,0.69 C916.762,334.206,840.536,333.639,840.422,390.574z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M979.851,267.848c0.837-26.51,39.768-26.455,40.448,0.139C1019.623,294.923,980.409,294.809,979.851,267.848z  M1015.605,323.758v134.459h-31.061V323.758H1015.605z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1048.599,390.021c1.808-93.082,142.706-92.379,143.432,1.106C1191.027,485.426,1048.448,485.123,1048.599,390.021z  M1080.35,390.574c-2.28,58.097,81.613,58.45,79.93,0.69C1162.045,333.953,1079.344,333.721,1080.35,390.574z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.324f2764da0d723ddeb105e7b6e910a4.svg";
export { ForwardRef as ReactComponent };